/**
 * Market Intelligence Page
 * 
 * Route wrapper for the Market Intelligence Dashboard
 * Handles page-level concerns like title, breadcrumbs, and layout
 */

import React from 'react';
import { Helmet } from 'react-helmet';
import MarketIntelligenceDashboard from '../components/MarketIntelligence/MarketIntelligenceDashboard';

const MarketIntelligencePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Market Intelligence | KairosIQ</title>
        <meta 
          name="description" 
          content="Real-time Arizona real estate market intelligence powered by 1.3M+ property records. AI-driven analytics for market temperature, trends, and ZIP code performance." 
        />
        <meta name="keywords" content="real estate, market intelligence, Arizona, ZIP codes, market trends, AI analytics" />
      </Helmet>

      <div className="market-intelligence-page">
        <MarketIntelligenceDashboard />
      </div>
    </>
  );
};

export default MarketIntelligencePage;